/**
 * Shared class strings for the Apple / Google sign-in buttons.
 *
 * Login and register render the SAME two buttons and had drifted: register
 * carried the outline both vendors' brand guidelines require (light #747775,
 * Google dark #8E918F), login had none — so on the dark login page the black
 * pills sat on the background with no edge at all. One constant per vendor so
 * the two screens cannot diverge again.
 */
export const APPLE_OAUTH_BUTTON =
  'w-full h-12 rounded-full bg-white text-[#1F1F1F] border border-[#747775] shadow-none hover:bg-white hover:opacity-90 dark:bg-black dark:text-white dark:border-white/30 dark:hover:bg-black';

export const GOOGLE_OAUTH_BUTTON =
  'w-full h-12 rounded-full bg-white text-[#1F1F1F] border border-[#747775] shadow-none hover:bg-white hover:opacity-90 dark:bg-[#131314] dark:text-white dark:border-[#8E918F] dark:hover:bg-[#131314]';
